import React, { useEffect, useState } from "react";
import { makeStyles, Drawer, Box, Divider, Typography } from "@material-ui/core";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SectionView from "./SectionView";
import SubSectionView from "./SubSectionView";
import DialogComponent from "../commonComponents/DialogComponent";
import DocumentViewer from "../commonComponents/DocumentViewer";



const drawerWidth = 320;
const useStyles = makeStyles((theme) => ({
    toolbar: theme.mixins.toolbar,
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        position: 'static',
        height: 'calc(100vh - 128px)',
        overflowY: 'auto',
    },
    listItems: {
        '& .MuiListItemIcon-root': {
            minWidth: theme.spacing(4),
            alignSelf: 'flex-start',
        },
    },
    nested: {

    },
    listSecondaryText: {
        fontSize: '0.65rem',
        lineHeight: '1',
        letterSpacing: 'normal',
    },

}));




export default function DrawerPanel({ currentSec, courseSection, onSectionContentShowClick, activeSubId, completedSecIds, completedSubIds, curriculumFlow, isFishish }) {
    const classes = useStyles();
    const [section, setSection] = React.useState([]);
    useEffect(() => {
        if (currentSec && currentSec != '') {
            let newData = [...section]
            if (!newData.includes(currentSec)) {
                newData.push(currentSec)
                setSection([...newData]);
            }
        }
    }, [currentSec])

    const [document, setDocument] = useState()

    const closeFileViwer = () => {
        setDocument(false);
    }
    const handleViewDocument = (name) => {
        setDocument(name)
    }


    const handleClick = (id) => {
        setAllSections(id)
    };

    const setAllSections = (id) => {
        let newData = [...section]
        if (!newData.includes(id)) {
            newData.push(id)
            setSection([...newData]);
        } else {
            setSection(newData.filter(x => x !== id))
        }
    }
    return (
        <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
                paper: classes.drawerPaper,
            }}

        >
            {/* <Toolbar /> */}
            <Box sx={{ overflow: 'auto' }}>
                <List disablePadding className={classes.listItems}>
                    <>
                        <ListItem dense>
                            <ListItemText primary={<Typography variant="body1" color="primary" style={{ fontWeight: '600', padding: '4px 0', }}>Course Content</Typography>} />
                        </ListItem>
                        <Divider />
                        {courseSection.filter(x => x.subSections.length > 0).map((item, i) => {
                            // if (item.hasChildren == true) {
                            return <SectionView item={item} seqNo={i + 1}
                                completedSecIds={completedSecIds}
                                completedSubIds={completedSubIds}
                                activeSubId={activeSubId}
                                section={section}
                                handleClick={handleClick}
                                onSectionContentShowClick={onSectionContentShowClick}
                                handleViewDocument={handleViewDocument}
                                curriculumFlow={curriculumFlow} isFishish={isFishish} />
                            // } else {
                            //    return <SubSectionView item={item} completedSecIds={completedSecIds} completedSubIds={completedSubIds} activeSubId={activeSubId} onSectionContentShowClick={onSectionContentShowClick} />
                            //  }
                        })}

                    </>
                </List>
            </Box>
            {document && <DialogComponent
                handleClose={closeFileViwer}
                open={document ? true : false}
                title="View"
                childComponent={
                    <DocumentViewer
                        documentName={document}
                        fileExtension={document?.split('.').pop()}
                    />
                }>
            </DialogComponent>
            }
        </Drawer>
    );
}



